export const customEmojis = [
  {
    id: 'party_parrot',
    name: 'Party Parrot',
    keywords: ['dance', 'dancing', 'parrot', 'party'],
    skins: [{ src: '/img/party_parrot.gif' }],
  },
  {
    id: 'keelearning',
    name: 'Keelearning',
    keywords: ['keelearning'],
    skins: [{ src: '/img/keelearning.png' }],
  },
]

// Build emoji-mart-vue compatible 'custom' array
// Spec for each item (emoji-mart v2):
// { name, short_names: [id], keywords, imageUrl }
export function getEmojiMartCustom() {
  const result = []
  for (const emoji of customEmojis) {
    const imgSrc = emoji.skins?.[0]?.src
    result.push({
      name: emoji.name,
      short_names: [emoji.id],
      keywords: emoji.keywords || [],
      // emoji-mart-vue expects absolute or public path
      imageUrl: imgSrc,
    })
  }
  return result
}

// Build an index compatible with @emoji-mart/data structure used in our dropdown/editor.
// Shape: { [id]: { id, name, keywords, skins: [{ src }] } }
export function getCustomEmojiIndex() {
  const index = {}
  for (const emoji of customEmojis) {
    const imgSrc = emoji.skins?.[0]?.src
    index[emoji.id] = {
      id: emoji.id,
      name: emoji.name,
      keywords: emoji.keywords || [],
      skins: imgSrc ? [{ src: imgSrc }] : [],
    }
  }
  return index
}
